import React, { FC } from 'react'
import Pagination from 'components/SA/Pagination'
import ResultsCount from 'components/SA/Pagination/ResultsCount'
import { handleScrollToTop } from 'components/SA/Facets/helpers'
import AlgoliaConnector, { ConnectorProps as AlgoliaProps } from 'connectors/Algolia/Algolia'
import { updateFeatureUrl } from 'apps/public/feature/helpers/url'

import UrlConnector, { ConnectorProps as UrlProps } from '../../connectors/Url'
import styles from './FeatureListPagination.module.scss'
import SelectHitsPerPage from '../SelectHitsPerPage'

type FeatureListPaginationProps = UrlProps & AlgoliaProps

const FeatureListPagination: FC<FeatureListPaginationProps> = (props) => {
  const { hitsPerPage, hitsTotal, currentPage, totalPages, getHref } = props

  return (
    <div className={styles.paginationContainer}>
      <Pagination
        current={currentPage + 1}
        total={totalPages}
        onClickLink={({ currentHref }) => {
          handleScrollToTop(() => updateFeatureUrl(currentHref))
        }}
        urlWithParam={getHref}
      />
      <ResultsCount hitsTotal={hitsTotal} hitsPerPage={hitsPerPage} currentPage={currentPage} />
      {!!hitsTotal && <SelectHitsPerPage />}
    </div>
  )
}

export default AlgoliaConnector(UrlConnector(FeatureListPagination))
